import { File, Image } from "@ludens-reklame/rubics-v3-sdk/file/types";
import { ButtonActionProps } from "../../internal-components/Button.js";
import type { BackgroundColor } from "../../types/theme.js";
import { HeroSlide } from "./default.js";
import { HeroSlider } from "./slider.js";
import { HeroVideo } from "./video.js";

interface Slide {
  title?: string;
  titleSize?: number;
  text?: string;
  image?: Image;
  mobileImage?: Image;
  actions?: ButtonActionProps[];
}

export interface Props extends Slide {
  slides?: Slide[];
  autoplay?: boolean;
  video?: File;
  backgroundColor?: BackgroundColor;
}

export const Hero: React.FunctionComponent<Props> = ({
  slides = [],
  autoplay,
  video,
  ...rest
}) => {
  if (video) {
    return <HeroVideo video={video} {...rest} />;
  }

  if (slides.length > 0) {
    return <HeroSlider slides={slides} autoplay={autoplay} />;
  }

  return <HeroSlide {...rest} />;
};
